import React, { useState, useEffect } from "react";
import { BtnPrimary } from "../../share/buttons/Btn";
import EmptyCourseDash from "../../share/EmptyCourseDash/EmptyCourseDash";
import Card from "../../share/cards/Card";
import IconButton from "../../share/buttons/IconButton";
import { Modal } from "../../share/modal/Modal";
import { ReactComponent as Trash } from "../../../Assets/Image/svg/trash.svg";
import { ReactComponent as Edit } from "../../../Assets/Image/svg/edit.svg";
import { ReactComponent as Add } from "../../../Assets/Image/svg/addSession.svg";
import { ReactComponent as TicketDot } from "../../../Assets/Image/svg/ticketDot.svg";
import useFetch from "../../../Hooks/useFetch";
import DiscountInfo from "../createcourse/discount/DiscountInfo";
import DiscountInfoCourse from "./DiscountInfoCourse";
import MainPagination from "../../share/Pageination/MainPagination";

const OffSection = () => {
    const [showModal, setShowModal] = useState(false);
    const [discounts, setDiscounts] = useState();
    const [pagination, setPagination] = useState({
        current: 1,
    });

    const handleCloseModal = () => {
        setShowModal((prev) => !prev);
    };

    const [del, setDel] = useState();
    const [edit, setEdit] = useState();

    const getDiscounts = useFetch({
        method: "GET",
        url: `DiscountService/11/discounts`,
        pagination: pagination,
        noHeader: false,
        trigger: true,
        setter: setDiscounts,
    });
    //TODO : id bootcamp dynamic she

    const deleteDiscount = useFetch({
        method: "DELETE",
        url: `DiscountService/${del}`,
        noHeader: false,
        caller: getDiscounts,
    });

    useEffect(() => {
        getDiscounts.reFetch();
    }, [pagination]);

    const handleDelete = (id) => {
        setDel(id);
        deleteDiscount.reFetch();
    };
    const handleEdit = (id) => {
        setEdit(id);
        setShowModal((prev) => !prev);
    };

    return (
        <div className=" mt-24 px-14">
            <div className="flex justify-between items-center mb-20">
                <h4 className="text-[2rem] text-purple-dark font-bold">
                    اطلاعات کد تخفیف‌ بوت کمپ
                </h4>
                <BtnPrimary
                    text="+ ایجاد کد تخفیف جدید"
                    className="px-16 py-7"
                    onClick={() => setShowModal(true)}
                />
            </div>
            {discounts?.results?.length !== 0 ? (
                <>
                    <Card className="flex justify-center items-center SupportTicketTable-card SupportTicketTable-body my-4 font-bold text-black-prim">
                        <div>نام کد تخفیف</div>
                        <div>درصد/مبلغ تخفیف</div>
                        <div>کد تخفیف</div>
                    </Card>
                    {discounts?.results?.map((i) => (
                        <Card
                            key={i.id}
                            className="SupportTicketTable-card SupportTicketTable-body my-4 relative"
                        >
                            <div className="absolute top-[31px] right-0">
                                <TicketDot />
                            </div>
                            <div className=" text-black-prim mr-8">
                                {i.discount_name}
                            </div>
                            {i.discount_percentage && (
                                <div>{i.discount_percentage} %</div>
                            )}
                            {i.discount_amount && (
                                <div>{i.discount_amount} تومان</div>
                            )}

                            <div
                                className=" text-purple-dark cursor-pointer"
                                onClick={() => {
                                    navigator.clipboard.writeText(
                                        i.discount_coupon_password
                                    );
                                }}
                            >
                                {i.discount_coupon_password}
                            </div>
                            <div className="">
                                {!i.checked && (
                                    <div className="flex justify-end">
                                        <IconButton
                                            data-tip="حذف"
                                            onClick={() => handleDelete(i.id)}
                                        >
                                            <Trash />
                                        </IconButton>
                                        <IconButton
                                            data-tip="ویرایش"
                                            onClick={() => handleEdit(i.id)}
                                        >
                                            <Edit />
                                        </IconButton>
                                    </div>
                                )}
                            </div>
                        </Card>
                    ))}
                    <MainPagination
                        pagination={pagination}
                        setPagination={setPagination}
                        data={discounts?.results}
                        pageSize={discounts?.page_count}
                        className="mt-[3rem]"
                    />
                </>
            ) : (
                <EmptyCourseDash name="جلسه" show={setShowModal} />
            )}
            <Modal show={showModal} closeModal={handleCloseModal}>
                <DiscountInfoCourse
                    getDiscounts={getDiscounts}
                    edit={edit}
                    setEdit={setEdit}
                    close={handleCloseModal}
                />
            </Modal>
        </div>
    );
};

export default OffSection;
